const { REACT_APP_BASE_API_URL } = process.env;

const ApiConfig = {
  baseUrl: REACT_APP_BASE_API_URL,
  urls: {
    auth: {
      login: "case-managers/sessions",
      profile: "me",
      change_password: "changePasswordCM",
      create_public_link: "create-public-link",
      remove_token: "remove-token",
      verifications: "/verifications",
      sessions: "sessions",
      otp_login: "otp-login",
      validate_mobile: "validate-mobile",
    },
    bookings: {
      getBookingsDet: "/getBookingsDet",
      dashboard: "/dashboard",
      invoices: "/invoices/",
      reports: "/reports",
      latestBookings: "/latest-bookings",
      addOnsiteService: "/bookings/add-onsite-service",
      capture_payment: "/bookings/capture-onsite-payment",
      capture_room_payment: "/capture-room-payment",
      book_room: "/book-room",
      availableSlots: "/available-slots",
      cancel_booking: "/cancel-booking",
      reschedule_booking: "/room-booking/reschedule",
      cancel_pending_reservation: "/cancel-pending-reservation",
    },
    party: {
      get: "casemanager/parties",
      approve: "casemanager/verify-party",
      updateParty: "casemanager/update-party-settings",
      index: "casemanager/parties",
      stats: "casemanager/users/parties-stats",
      profileParties: "casemanager/users/parties",
      partyStats: "casemanager/party-stats",
      resupdate: "casemanager/updateRespondentParties",
      getPartyCodes: "/getPartyCodes",
    },
    case: {
      caseIndex: "cases",
      case: "casemanager",
      index: "casemanager/cases",
      stats: "stats",
      caseStats: "casemanager/case-stats",
      assignCase: "admin/cases",
      uploads: "casemanager/uploads",
      bulkUpload: "casemanager/uploads/bulkCaseUpload",
      reprocessDuplicates: "bulkCaseUploadArbitration/reprocess-duplicates",
      updateStatusByBatch: "cases/update-status-by-batch",
      part2Review: "bulk-uploads/part2-review",
      part2Approval: "bulk-uploads/part2-approval",
      saveSummary: "casemanager/summary",
      uploadAgreement: "negotiationAgreement",
      caseAgreementUpload: "casemanager/uploads/case",
      uploadStats: "casemanager/stats",
      case_document_uploads: "casemanager/case-document-uploads",
      mediation: "casemanager/mediation",
      negotiation: "casemanager/negotiation",
      uploadCase: "casemanager/uploads/case",
      getCaseDocuments: "casemanager/uploads",
      pendingAction: "casemanager/activities",
      offlinePayment: "payment-capture-offline",
      comments: "/comments",
      paymentRefund: "/casemanager/payments/refund",
      orders: "/orders",
      notificationCount: "/casemanager/notification-count",
      draft: "/cases/drafts",
      selectDraft: "/selects/drafts",
      select: "/selects/case",
      notes: "/notes",
      uploadDocCase: "uploads/case",
      transcripts: "/transcripts",
      updateClaimDescription: "/updateClaimDescription",
      reOpenCase: "/reOpenCase",
      getTranscriptionData: "/getTranscriptionData",
      transcriptionControlCM: "/transcriptionControlCM",
      getLiveTranscription: "/getLiveTranscription",
      enableLiveTranscription: "/enableLiveTranscription",
      getLiveTranscriptionData: "/getLiveTranscriptionData",
      updateLiveTranscriptionData: "/updateLiveTranscriptionData",
      updateTranscriptionData: "/updateTranscriptionData",
      presidingArbitrator: "/presidingArbitrator",
      startTranscription: "/startTranscription",
      transcriptionControl: "/transcriptionControl",
      downloadComments: "/downloadComments",
      getMeetingAudioTranscript: "/getMeetingAudioTranscript",
      updateAudioTranscriptData: "/updateAudioTranscriptData",
      mergeAudioTranscriptData: "/mergeAudioTranscriptData",
      getExcelFields: "/getExcelFields",
      bulkNoticeGenerate: "/bulkNoticeGenerate",
      passiveusers: "/casemanager/users",
      passiveNeutral: "/passiveNeutral",
      removePassiveUser: "/removePassiveUser",
      getUsersCount: "/casemanager/getUsersCount",
      sendDocument: "/sendDocument",
      sendDocumentByWhatsapp: "/sendDocumentByWhatsapp",
      generateInvoice: "/generateInvoice",
      getPhoneNumbers: "/getPhoneNumbers",
      getCaseDetailsForInvoice: "/getCaseDetailsForInvoice",
      dailyCauseList: "/dailyCauseList",
      modifyHearingEvent: "/casemanager/modifyHearingEvent",
      pushCaseToArbitration: "/pushCaseToArbitration",
      reOpenCaseCM: "/reOpenCaseCM",
      generateInvoiceCase: "/generateInvoiceCase",
      casesForMIS: "/casesForMIS",
      downloadMIS: "/downloadMIS",
      bulkUploadDocuments: "/bulkUploadDocuments",
      getDocumentsReport: "/getDocumentsReport",
      getDocumentTypes: "/getDocumentTypes",
      excelMapping: "/excelMapping",
      getExcelMapping: "/getExcelMapping",
      clientExcelMapping: "/clientExcelMapping",
      splitUpload: "/splitUpload",
      splitPDFWithPages: "/splitPDFWithPages",
      mergeUpload: "/mergeUpload",
      splitDownload: "/splitDownload",
      makerChecker: "/makerChecker",
      getCmList: "/admin/case-managers",
      findByContract: "/cases/findByContract",
      bulkCaseUpload: "/delete/bulkCaseUpload",
      createNeutralByCM: "/createNeutralByCM",
      reportDetails: "reportDetails",
      uploadCaseData: "/upload-cases-data",
      sendInvoiceMail: "/sendInvoiceMail",
      generate_invoice_bulk: "/generateInvoiceBulk",
      reportsDownload: "/reportsDownload",
      getCaseStages: "/getCaseStages",
    },
    bulkdownload: {
      getBulkDownloadDocumentDet: "/getBulkDownloadDocumentDet",
      bulkDownloadDocuments: "/bulk-download-documents",
      bulkUpdates: "/bulkUpdates",
      contested: "/cases/contested",
    },
    transcribers: {
      getTranscribersList: "/getTranscribersList",
      assignTranscribers: "/assignTranscribers",
      transcriber: "/transcribers",
      esigners: "/esigners",
      transcriberDetails: "/transcriber",
      transcriberCases: "/transcriberCases",
      CMTranscriberCases: "/CMTranscriberCases",
      getTranscribersListForLive: "/getTranscribersListForLive",
      transcriberCasesStats: "/transcriberCasesStats",
      getSpeakerNames: "/getSpeakerNames",
      postProcessingTranscripts: "/postProcessingTranscripts",
      getTranscribersListForRecordings: "/getTranscribersListForRecordings",
      updateEsignedFile: "/update-esignedFile",
      extractCaseDetails: "/extractCaseDetails",
    },
    payment: {
      payments: "/payments",
    },
    transcription: {
      getTranscriptionStatus: "/getTranscriptionStatus",
      moveTranscriptToDoc: "/moveTranscriptToDoc",
      postTranscriptionData: "/postTranscriptionData",
      updateXExamTranscript: "/updateXExamTranscript",
      moveTranscriptToRecordings: "/moveTranscriptToRecordings",
      updateXExamTranscriptDoc: "/updateXExamTranscriptDoc",
      transcriptionDetails: "/transcription-details",
      movedTranscription: "/moved-transcription",
      liveTranscriptSegments: "/live-transcript-segments",
    },
    notice: {
      getNoticeTemplates: "/getNoticeTemplates",
      getNoticeTemplate: "/getNoticeTemplate",
      bulkNoticeGenerate: "/bulkNoticeGenerate",
      uploadNoticeTemplates: "/uploadNoticeTemplates",
      addLetterHeadOption: "/addLetterHeadOption",
      getLetterHeadOption: "/getLetterHeadOption",
      noticeDesign: "/noticeDesign",
      updateNoticeOutput: "/notices/updateNoticeOutput",
      noticeTracking: "/notice-tracking",
      trackingList: "/tracking-list",
      token: "/tracking-token",
      gettracking: "/get-tracking-details",
    },
    meeting: {
      meetings: "/meetingJoin",
      guestmeetingUrl: "/guestMeetingUrl",
      meetingRecordings: "/meetingRecordings",
      genericMeetingJoin: "/genericMeetingJoin",
      genericMeetingRecordings: "/genericMeetingRecordings",
      genericMeetingUrl: "/genericMeetingUrl",
      genericMeeting: "/genericMeeting",
      mettingcase: "/getMeetingDet",
      endMeeting: "/endMeeting",
      publishTranscripts: "/publishTranscripts",
      recordControl: "/recordControl",
      meetingControl: "/meetingControl",
      stopTranscription: "/stopTranscription",
      getMeetingAudioDetails: "/getMeetingAudioDetails",
      getAudioFile: "/getAudioFile",
      liveTranscriptDet: "/liveTranscriptDet",
      getCasesDetails: "/getCasesDetails",
      getCaseMeetingDetails: "/getCaseMeetingDetails",
      updateMeetingDetails: "/updateMeetingDetails",
      selectMeetingAudioDetails: "/selectMeetingAudioDetails",
      generateRTMPLink: "/generateRTMPLink",
      createMeetingUrlArb: "/createMeetingUrlArb",
      getMeetingUrlArb: "/getMeetingUrlArb",
      meetingRecordingDetArb: "/MeetingRecordingDetArb",
      arbitratorJoinMeeting: "/arbitratorJoinMeeting",
      joinMeetingUrlArb: "/joinMeetingUrlArb",
      deteleMeetingLink: "/delete-meeting-link",
      deleteEsignerLink: "/delete-esigner-link",
      communicationTemplates: "/communicationTemplates",
      communicationLogs: "/communication/logs",
      whatsappLogs: "/whatsappLogs",
      smsLogs: "/smsLogs",
    },
    bundle: {
      customBundle: "/customBundle",
      bundleDocList: "/documentList",
      addPageNumberBundle: "/addPageNumberBundle",
      generateTableofContentsBundle: "/generateTableofContentsBundle",
      addAnnotationToBundles: "/addAnnotationToBundles",
      deletePagesFromBundle: "/deletePagesFromBundle",
      addSectionOrPagesToBundle: "/addSectionOrPagesToBundle",
      addPagesToBundle: "/addPagesToBundle",
      A4ST12AddressLable: "/A4ST12AddressLable",

      //new bundle url

      createBundle: "/createBundle",
      updateBundle: "/updateBundle",
      getBundleDocuments: "/getBundleDocuments",
      deleteBundleItem: "/deleteBundleItem",
      combineBundles: "/combineBundles",
      uploadDocumentsToBundle: "/uploadDocumentsToBundle",
      moveDocument: "/moveDocument",
    },
    systemConfig: "system-configs",
    systemConfigAgreement: "casemanager/system-configs",
    s3: "s3-url",
    notificationCount: "/notification-count",
    createEsignIn: "/create-esign-in",
    pricingUpload: "/upload-pricing",
    user: {
      index: "casemanager/users",
      update: "casemanager/update-user",
    },
    // EPE (JustCue): JustAct-Backend proxies these to the JustCue server
    epe: {
      access: (caseId) => `epe/cases/${encodeURIComponent(caseId)}/access`,
      launch: (caseId) => `epe/cases/${encodeURIComponent(caseId)}/launch`,
      participants: (caseId) =>
        `epe/cases/${encodeURIComponent(caseId)}/participants`,
      operator: (caseId, userId) =>
        `epe/cases/${encodeURIComponent(caseId)}/operators/${encodeURIComponent(userId)}`,
      newSession: (caseId) =>
        `epe/cases/${encodeURIComponent(caseId)}/session/new`,
    },
    estamp: {
      preview: "casemanager/estamps/preview",
      confirm: "casemanager/estamps/confirm",
      splitBatch: "casemanager/estamps/split-batch",
      jobStatus: (id) =>
        `casemanager/estamps/${encodeURIComponent(id)}/job-status`,
      partyStock: (partyId) =>
        `casemanager/parties/${encodeURIComponent(partyId)}/estamps`,
    },
  },
};

export default ApiConfig;
